module.exports = __webpack_public_path__ + "media/images/common/side_bg_btm-e3e99921b145cce26e55c5a43ca9779f.gif";